import React from 'react';
import {InputAdornment, TextField} from "@mui/material";
import {EmailOutlined} from "@mui/icons-material";
import T from 'i18n-react';

const EmailInput = ({isError}) => {

    return (
        <TextField
            name={'email'}
            placeholder={T.translate('resetPasswordComponent.email')}
            type={'email'}
            error={isError}
            InputProps={{
                startAdornment: (
                    <InputAdornment position={'start'}>
                        <EmailOutlined/>
                    </InputAdornment>
                )
            }}
        />
    );
};

export default EmailInput;
